var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42_50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.1333,
    y: 13.5439,
    width: 80,
    height: 80,
    rx: 15,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8783 70.4189C58.0108 70.4189 55.5683 69.4177 53.5508 67.4152C51.5333 65.4127 50.5245 62.9764 50.5245 60.1064V59.1371C48.1495 58.9158 46.1495 57.9158 44.5245 56.1371C42.8995 54.3608 42.087 52.2464 42.087 49.7939V39.4814H47.712V37.6064H49.587V43.2314H47.712V41.3564H43.962V49.7939C43.962 51.8564 44.6964 53.6221 46.1652 55.0908C47.6339 56.5596 49.3995 57.2939 51.462 57.2939C53.5245 57.2939 55.2902 56.5596 56.7589 55.0908C58.2277 53.6221 58.962 51.8564 58.962 49.7939V41.3564H55.212V43.2314H53.337V37.6064H55.212V39.4814H60.837V49.7939C60.837 52.2464 60.0245 54.3614 58.3995 56.1389C56.7745 57.9164 54.7745 58.9158 52.3995 59.1371V60.1064C52.3995 62.4502 53.2233 64.4427 54.8708 66.0839C56.5208 67.7239 58.5227 68.5439 60.8764 68.5439C63.2202 68.5439 65.212 67.7239 66.852 66.0839C68.492 64.4439 69.3127 62.4514 69.3139 60.1064V57.1814C68.4364 56.9752 67.712 56.5139 67.1408 55.7977C66.5695 55.0814 66.2839 54.2577 66.2839 53.3264C66.2839 52.2264 66.6702 51.2902 67.4427 50.5177C68.2152 49.7464 69.1527 49.3608 70.2552 49.3608C71.3577 49.3608 72.2939 49.7464 73.0639 50.5177C73.8339 51.2889 74.2183 52.2258 74.217 53.3283C74.217 54.2583 73.9314 55.0814 73.3602 55.7977C72.7902 56.5139 72.0664 56.9758 71.1889 57.1833V60.1064C71.1889 62.9764 70.1877 65.4127 68.1852 67.4152C66.1827 69.4177 63.747 70.4189 60.8783 70.4189ZM70.2477 55.4189C70.8277 55.4189 71.3214 55.2152 71.7289 54.8077C72.1364 54.4002 72.3402 53.9064 72.3402 53.3264C72.3402 52.7464 72.1364 52.2533 71.7289 51.8471C71.3214 51.4408 70.8277 51.2371 70.2477 51.2358C69.6677 51.2346 69.1745 51.4383 68.7683 51.8471C68.362 52.2558 68.1583 52.7496 68.157 53.3283C68.1558 53.9071 68.3595 54.4002 68.7683 54.8077C69.177 55.2152 69.6689 55.4189 70.2477 55.4189Z",
    fill: "#B310FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42_50",
    x: 0.912466,
    y: 0.915333,
    width: 114.442,
    height: 114.442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.59222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.61042
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.823529 0 0 0 0 0.988235 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_50",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedure);
export default __webpack_public_path__ + "static/media/Procedure.3b014242a93e0f3da81692e427ef7ca0.svg";
export { ForwardRef as ReactComponent };